/* App.js */
import "./App.css";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { initializeLoginData } from "./Redux/Slice/Auth";
import Layout from "./Layout/Layout";
import Login from "./Page/Login/Login";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DebugBlocked from "./Page/DebugBlocked";

function App() {
  const dispatch = useDispatch();
  const { LoginData } = useSelector((state) => state.auth || {});

  const [isClient, setIsClient] = useState(false);
  const [apiBlocked, setApiBlocked] = useState(false);

  // ---------------- 🛑 Detect Mobile Device ---------------- //
  const isMobileDevice = () => {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
      navigator.userAgent
    );
  };

  // ----------- 🚨 ENHANCED DEVTOOLS DETECTION (DISABLED ON MOBILE) --------------- //
  const detectDevTools = () => {
    if (isMobileDevice()) return false; // 🔥 MOBILE ALWAYS SAFE

    const consoleTampered = !console.log || typeof console.log !== "function";

    // In production, timing-based debugger detection can be flaky, especially with obfuscation.
    // We'll rely on console tampering as a safer indicator and disable window dimensions checks.
    return consoleTampered;
  };

  // ----------- 🚨 INTERCEPT ALL API CALLS --------------- //
  const interceptAPICalls = () => {
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
      if (apiBlocked) {
        return Promise.reject(
          new Error("API calls blocked - Debug mode detected")
        );
      }
      return originalFetch.apply(this, args);
    };
  };

  // ----------- 🚫 DISABLE RIGHT CLICK --------------- //
  const disableRightClick = () => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);
    return () => document.removeEventListener("contextmenu", handleContextMenu);
  };

  useEffect(() => {
    interceptAPICalls();

    const cleanupRightClick = disableRightClick();
    setIsClient(true);

    // ------------ 🛑 Disable Shortcuts (Desktop Only) ---------- //
    const handleKeyDown = (e) => {
      if (isMobileDevice()) return; // 🔥 MOBILE SAFE

      if (e.key === "F12") {
        e.preventDefault();
        setApiBlocked(true);
      }

      if (
        e.ctrlKey &&
        e.shiftKey &&
        ["i", "j", "c"].includes(e.key.toLowerCase())
      ) {
        e.preventDefault();
        setApiBlocked(true);
      }

      if (e.ctrlKey && e.key.toLowerCase() === "u") {
        e.preventDefault();
        setApiBlocked(true);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    // ----------- 🛑 Desktop DevTools Detection ---------- //
    const checkDevTools = () => {
      if (!isMobileDevice() && detectDevTools()) {
        setApiBlocked(true);
        localStorage.removeItem("authToken");
        sessionStorage.removeItem("authToken");
      }
    };

    const interval = setInterval(checkDevTools, 500);

    if (!detectDevTools()) dispatch(initializeLoginData());
    else setApiBlocked(true);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      clearInterval(interval);
      cleanupRightClick();
    };
  }, [dispatch]);

  useEffect(() => {
    interceptAPICalls();
    if (apiBlocked) {
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("authToken");
    }
  }, [apiBlocked]);

  if (!isClient) return null;

  const isLoggedIn = !!LoginData && !apiBlocked;

  const handleLoginSuccess = () => {
    if (!apiBlocked) dispatch(initializeLoginData());
  };

  return (
    <>
      <ToastContainer />
      {!apiBlocked ? (
        isLoggedIn ? (
          <Layout />
        ) : (
          <Login onLoginSuccess={handleLoginSuccess} />
        )
      ) : (
        <DebugBlocked />
      )}
    </>
  );
}

export default App;
